exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#menuUpload{margin-top:15px!important;position:absolute;z-index:50;max-height:16em!important;width:16em!important}#menuUpload .message-body{border-radius:0}#menuUpload .message-body,#menuUpload .message-footer{background-color:#fff;border-left:1px solid hsla(0,0%,73%,.99);border-right:1px solid hsla(0,0%,73%,.99);border-bottom:1px solid hsla(0,0%,73%,.99)}#menuUpload .message-footer{border-radius:0 0 4px 4px;min-height:30px;display:flex;justify-content:space-between;text-align:center;padding:.5em 1em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d21ad1f8","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/frpm/components/uploadFile.vue
// module id = 607
// module chunks = 2